import { I18n } from '@app/i18n/strings-keys';

/**
 * @deprecated not used
 */
export enum ORDER_PDF_HEADER_NAMES {
  ItemName = 'Item Name',
  GlAccount = 'GL Account',
  OrderingUnit = 'Ordering Unit',
  QuantityOrdered = 'Quantity Ordered',
  UnitCost = 'Unit Cost',
  OrderExtendedCost = 'Order Extended Cost',
  QuantityReceived = 'Quantity Received',
  ReceivedUnitCost = 'Received Unit Cost',
  ReceivedExtendedCost = 'Received Extended Cost',
  TotalItemsCost = 'Total Item(s) Cost',
  DeliveryFee = 'Delivery Fee',
  SalesTax = 'Sales Tax',
  GrandTotal = 'Grand Total',
}

export enum ORDER_PDF_HEADER_VALUES {
  ItemName = 'item_name',
  GlAccount = 'gl_account_name',
  OrderingUnit = 'ordering_unit',
  Count = 'count',
  InitialCount = 'initial_count',
  ItemCost = 'item_cost',
  TotalCost = 'total_cost',
  InitialTotalCost = 'initial_total_cost',
  InitialQuantity = 'initial_count',
  UnitCost = 'item_cost',
  InitialUnitCost = 'initial_item_cost',
  QuantityReceived = 'quantity_received',
  Name = 'name',
  Measures = 'measures',
}

export enum ORDER_PDF_SUMMARY_NAMES {
  Vendor = 'Vendor: ',
  OrderDate = 'Order Date: ',
  ExternalReferenceNumber = 'Ext. Ref. No.: ',
  Status = 'Status: ',
  Warehouse = 'Warehouse: ',
  DeliveryDate = 'Delivery Date: ',
  InvoiceNumber = 'Invoice No.: ',
}

/**
 * @deprecated not used
 */
export const ORDER_PDF_HEADERS = [
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.ItemName,
      width: '30%',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.ItemName,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.GlAccount,
      width: '15%',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.GlAccount,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.OrderingUnit,
      width: 'auto',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.OrderingUnit,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.QuantityOrdered,
      textAlign: 'right',
      width: '*',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.Count,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.UnitCost,
      textAlign: 'right',
      width: '*',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.ItemCost,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.OrderExtendedCost,
      textAlign: 'right',
      width: '*',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.TotalCost,
  },
];

/**
 * @deprecated not used
 */
export const ORDER_PDF_HEADERS_FINAL = [
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.ItemName,
    },
    dataKey: ORDER_PDF_HEADER_VALUES.ItemName,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.GlAccount,
    },
    dataKey: ORDER_PDF_HEADER_VALUES.GlAccount,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.OrderingUnit,
    },
    dataKey: ORDER_PDF_HEADER_VALUES.OrderingUnit,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.QuantityOrdered,
      textAlign: 'right',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.InitialCount,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.UnitCost,
      textAlign: 'right',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.InitialUnitCost,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.OrderExtendedCost,
      textAlign: 'right',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.InitialTotalCost,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.QuantityReceived,
      textAlign: 'right',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.Count,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.ReceivedUnitCost,
      textAlign: 'right',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.ItemCost,
  },
  {
    header: {
      text: ORDER_PDF_HEADER_NAMES.ReceivedExtendedCost,
      textAlign: 'right',
    },
    dataKey: ORDER_PDF_HEADER_VALUES.TotalCost,
  },
];

/**
 * @deprecated not used
 */
export const ORDER_PDF_TOTAL_HEADERS = [
  {
    text: ORDER_PDF_HEADER_NAMES.GlAccount,
  },
  {
    text: ORDER_PDF_HEADER_NAMES.QuantityOrdered,
    textAlign: 'right',
  },
  {
    text: ORDER_PDF_HEADER_NAMES.OrderExtendedCost,
    textAlign: 'right',
  },
];

/**
 * @deprecated not used
 */
export const ORDER_PDF_TOTAL_HEADERS_FINAL = [
  {
    text: ORDER_PDF_HEADER_NAMES.GlAccount,
  },
  {
    text: ORDER_PDF_HEADER_NAMES.QuantityOrdered,
    textAlign: 'right',
  },
  {
    text: ORDER_PDF_HEADER_NAMES.OrderExtendedCost,
    textAlign: 'right',
  },
  {
    text: ORDER_PDF_HEADER_NAMES.QuantityReceived,
    textAlign: 'right',
  },
  {
    text: ORDER_PDF_HEADER_NAMES.ReceivedExtendedCost,
    textAlign: 'right',
  },
];

/**
 * @deprecated not used
 */
export const ORDER_PDF_ORDER_SUMMARY_HEADERS = [
  {
    text: ORDER_PDF_HEADER_NAMES.TotalItemsCost,
    textAlign: 'right',
  },
  {
    text: ORDER_PDF_HEADER_NAMES.DeliveryFee,
    textAlign: 'right',
  },
  {
    text: ORDER_PDF_HEADER_NAMES.SalesTax,
    textAlign: 'right',
  },
  {
    text: ORDER_PDF_HEADER_NAMES.GrandTotal,
    textAlign: 'right',
  },
];

export const ORDER_PDF_HEADERS_CONFIG = [
  {
    title: I18n.Forms.GridForm.ItemName,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.GLAccount,
  },
  {
    title: I18n.Forms.GridForm.OrderingUnit,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.QuantityOrdered,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.UnitCost,
  },
  {
    title: I18n.Forms.GridForm.OrderExtendedCost,
  },
  {
    title: I18n.Forms.GridForm.QuantityReceived,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.ReceivedUnitCost,
  },
  {
    title: I18n.Forms.GridForm.ReceivedExtendedCost,
  },
];

export const ORDER_PDF_FOR_OPEN_OR_CANCEL = [
  {
    title: I18n.Forms.GridForm.ItemName,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.GLAccount,
  },
  {
    title: I18n.Forms.GridForm.OrderingUnit,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.QuantityOrdered,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.UnitCost,
  },
  {
    title: I18n.Forms.GridForm.OrderExtendedCost,
  },
];
